export default __webpack_public_path__ + "static/media/calendar-blue.26dc6a75.svg";